import { WeekStartsOn } from '@opallabs/concepts'
import { getNestedProperty } from '@opallabs/lambda'

/**
 * Check which day of the week (Sunday, Monday, ...) to use as the first day
 * of the week when displaying calendars.
 *
 * @returns {(0|1|2|3|4|5|6)} `0` is Sunday, `1` is Monday, ...
 */
export function getWeekStartsOn(): WeekStartsOn {
  const userSettings = getNestedProperty(
    window,
    'Opal',
    'State',
    'global_settings'
  )
  if (userSettings) {
    const userSetting = userSettings.get('start_of_week')
    if (Number.isInteger(userSetting)) return userSetting
  }

  const globalState = getNestedProperty(
    window,
    'OpalMoments',
    'State',
    'settings'
  )
  if (globalState) {
    const workspaceId = globalState.get('current_brand_id')
    const workspaces = getNestedProperty(
      window,
      'OpalMoments',
      'Collections',
      'brands'
    )

    let workspaceModel
    if (workspaces) workspaceModel = workspaces.get(workspaceId)

    if (workspaceModel) {
      const workspaceSetting = workspaceModel.get('start_of_week')
      if (Number.isInteger(workspaceSetting)) return workspaceSetting
    }
  }

  return WeekStartsOn.Sunday
}
